import { useTheme } from '@material-ui/core'
import React from 'react'

const IconButton = ({ children, className, disabled, onClick, title }) => {
  const theme = useTheme()

  return (
    <button
      title={title}
      type='button'
      onClick={onClick}
      disabled={disabled}
      css={`
        display: flex;
        appearance: none;
        cursor: pointer;
        border: 0;
        background-color: transparent;
        padding: 0;
        color: grey;
        transition: color 0.2s;
        &:hover {
          color: ${theme.palette.type === 'dark' ? 'white' : 'black'};
        }
      `}
      className={className}>
      {children}
    </button>
  )
}

export default IconButton
